export default "__VITE_ASSET__ChStuwh4__";